const development = {
    // base_url_static: ["http://static.nm.local/"]
    base_url_static: [
         "https://static01.staging.kidsmatin.com/",
         "https://static02.staging.kidsmatin.com/",
         "https://static03.staging.kidsmatin.com/"
     ]
 };
 
 const staging = {
    base_url_static: [
        "https://static01.staging.kidsmatin.com/",
        "https://static02.staging.kidsmatin.com/",
        "https://static03.staging.kidsmatin.com/"
    ]
 };
 
 const production = {
    base_url_static: [
        "https://static01.kidsmatin.com/",
        "https://static02.kidsmatin.com/",
        "https://static03.kidsmatin.com/"
   ]
 };

let staticConf = development;
if( process.env.REACT_APP_ENV !== undefined && ['development', 'staging', 'production'].includes(process.env.REACT_APP_ENV) ) {
  if( process.env.REACT_APP_ENV === 'production' ) staticConf = production;
  else if( process.env.REACT_APP_ENV === 'staging' ) staticConf = staging;
}

export default staticConf;


// WEBPACK FOOTER //
// ./src/conf/static.js